import { getWeek, parse, startOfYear } from "date-fns"
import { Constants } from "../constants"
import dayjs from "dayjs"

export const ToDate = (date: Date | string): Date => {
  const newDate = new Date(date)
  newDate.setMinutes(newDate.getMinutes() + newDate.getTimezoneOffset())
  return newDate
}

const getNumberWeek = (value: string | Date | number) => {
  const dayIsMonday = startOfYear(new Date()).getDay() == 1
  let week  = 0
  if (typeof value == 'string') {
    week = getWeek(new Date(parse(value, Constants.dateFormat, new Date())), { weekStartsOn: 1 })
  } else {
    week = getWeek(new Date(value), { weekStartsOn: 1 })
  }
  if (!dayIsMonday) { week = week - 1 }

  return week
}

export const applyTimeZoneAndReturnDate = ({date, code}:{date: Date | string; code: string}): Date => new Date(dayjs.utc(date).tz(code).format('YYYY-MM-DDTHH:mm:ss.SSS'))
const getActivedWeek = (value: number | Date | string) => getWeek(new Date(value), { weekStartsOn: 1 })

export { getNumberWeek, getActivedWeek }